"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsgapFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TsgapFactory = /** @class */ (function (_super) {
    __extends(TsgapFactory, _super);
    function TsgapFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TsgapFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    TsgapFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    TsgapFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TsgapFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TsgapFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TsgapFactory;
}(contracts_1.ContractFactory));
exports.TsgapFactory = TsgapFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'appointeeAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'appointeeStatus',
                type: 'bool',
            },
        ],
        name: 'AppointeeUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'appointeeAddress',
                type: 'address',
            },
        ],
        name: 'AppointeeVoted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'fromMonthId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'toMonthId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'withdrawlAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'withdrawnBy',
                type: 'address',
            },
        ],
        name: 'BenefitWithdrawl',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'depositAmount',
                type: 'uint256',
            },
        ],
        name: 'FundsDeposited',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'withdrawlAmount',
                type: 'uint256',
            },
        ],
        name: 'FundsWithdrawn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'monthId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'depositAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'benefitQueued',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'depositedBy',
                type: 'address',
            },
        ],
        name: 'NewDeposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'monthlyCommitmentAmount',
                type: 'uint256',
            },
        ],
        name: 'NewSIP',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nomineeAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'nomineeStatus',
                type: 'bool',
            },
        ],
        name: 'NomineeUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'sipId',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint32',
                name: 'boosterSerial',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'withdrawlAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'withdrawnBy',
                type: 'address',
            },
        ],
        name: 'PowerBoosterWithdrawl',
        type: 'event',
    },
    {
        inputs: [],
        name: 'EARTH_SECONDS_IN_MONTH',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'addFunds',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
        ],
        name: 'appointeeVote',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_minimumMonthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: '_accumulationPeriodMonths',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_benefitPeriodYears',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_gracePeriodSeconds',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_monthlyBenefitFactor',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_gracePenaltyFactor',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_defaultPenaltyFactor',
                type: 'uint32',
            },
        ],
        name: 'createSIPPlan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'fundsDeposit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_monthId',
                type: 'uint32',
            },
        ],
        name: 'getDepositDoneStatus',
        outputs: [
            {
                internalType: 'enum TSGAP.DepositStatus',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_monthId',
                type: 'uint32',
            },
        ],
        name: 'getDepositStatus',
        outputs: [
            {
                internalType: 'enum TSGAP.DepositStatus',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_withdrawlMonthId',
                type: 'uint32',
            },
            {
                internalType: 'bool',
                name: '_isNomineeWithdrawing',
                type: 'bool',
            },
        ],
        name: 'getPendingWithdrawlAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
        ],
        name: 'getSip',
        outputs: [
            {
                internalType: 'uint32',
                name: 'planId',
                type: 'uint32',
            },
            {
                internalType: 'uint48',
                name: 'stakingTimestamp',
                type: 'uint48',
            },
            {
                internalType: 'uint256',
                name: 'monthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'totalDeposited',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: 'lastWithdrawlMonthId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'powerBoosterWithdrawls',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'numberOfAppointees',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'appointeeVotes',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_monthId',
                type: 'uint32',
            },
            {
                internalType: 'enum TSGAP.DepositStatus',
                name: '_depositStatusAdmin',
                type: 'uint8',
            },
        ],
        name: 'migrateDeposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_planId',
                type: 'uint32',
            },
            {
                internalType: 'uint48',
                name: '_stakingTimestamp',
                type: 'uint48',
            },
            {
                internalType: 'uint32',
                name: '_lastWithdrawlMonthId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_powerBoosterWithdrawls',
                type: 'uint32',
            },
        ],
        name: 'migrateSip',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_monthId',
                type: 'uint32',
            },
        ],
        name: 'monthlyDeposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_planId',
                type: 'uint32',
            },
        ],
        name: 'newSIP',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pendingBenefitAmountOfAllStakers',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'sipPlans',
        outputs: [
            {
                internalType: 'bool',
                name: 'isPlanActive',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'minimumMonthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: 'accumulationPeriodMonths',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'benefitPeriodYears',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'gracePeriodSeconds',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'monthlyBenefitFactor',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'gracePenaltyFactor',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'defaultPenaltyFactor',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'sips',
        outputs: [
            {
                internalType: 'uint32',
                name: 'planId',
                type: 'uint32',
            },
            {
                internalType: 'uint48',
                name: 'stakingTimestamp',
                type: 'uint48',
            },
            {
                internalType: 'uint256',
                name: 'monthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'totalDeposited',
                type: 'uint256',
            },
            {
                internalType: 'uint32',
                name: 'lastWithdrawlMonthId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'powerBoosterWithdrawls',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'numberOfAppointees',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: 'appointeeVotes',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: '_newAppointeeStatus',
                type: 'bool',
            },
        ],
        name: 'toogleAppointee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_nomineeAddress',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: '_newNomineeStatus',
                type: 'bool',
            },
        ],
        name: 'toogleNominee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_planId',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_newStatus',
                type: 'bool',
            },
        ],
        name: 'updatePlanStatus',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_sipId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
        ],
        name: 'viewAppointation',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_depositMonthId',
                type: 'uint32',
            },
        ],
        name: 'viewMonthlyBenefitAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_sipId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_nomineeAddress',
                type: 'address',
            },
        ],
        name: 'viewNomination',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
            {
                internalType: 'uint32',
                name: '_withdrawlMonthId',
                type: 'uint32',
            },
        ],
        name: 'withdrawBenefit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_withdrawlAmount',
                type: 'uint256',
            },
        ],
        name: 'withdrawFunds',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_sipId',
                type: 'uint32',
            },
        ],
        name: 'withdrawPowerBooster',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TsgapFactory.js.map